import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const RTL_LANGUAGES = new Set(["he", "ar"]);

export function useDirection() {
  const { i18n } = useTranslation();
  const isRtl = RTL_LANGUAGES.has(i18n.language);

  useEffect(() => {
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
  }, [i18n.language, isRtl]);

  return { isRtl };
}
